import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { Stack } from '@mui/material';
import { MUICheckbox } from 'modules/Core/Common';

export function TableCheckbox({
  isSelected,
  onSelect,
  indeterminate,
  disabled,
  component,
}) {
  const theme = useTheme();

  return (
    <Stack
      component={component || 'td'}
      onClick={(e) => e.stopPropagation()}
      sx={{
        '&&&': {
          width: 48,
          height: 60,
          px: 2,
        },
        '.MuiTypography-root': {
          fontSize: '14px',
          lineHeight: '16px',
          color: theme.config.colors.gray,
        },
      }}
    >
      <MUICheckbox
        checked={!!isSelected}
        disabled={disabled}
        onChange={(e) => {
          e.stopPropagation();
          onSelect(e.target.checked);
        }}
        checkboxProps={{
          disableRipple: true,
          indeterminate: !!indeterminate,
        }}
      />
    </Stack>
  );
}

TableCheckbox.propTypes = {
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  indeterminate: PropTypes.bool,
  disabled: PropTypes.bool,
  component: PropTypes.string,
};
